
import { yupResolver } from '@hookform/resolvers/yup';
import { AxiosError } from 'axios';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import StickButtonsBloc from '../../blocs/common/StickButtonsBloc';
import { APP_URLS, ERROR_MESSAGES } from '../../const/AppConst';
import useAppState from '../../context/AppContext';
import MgpFormInput from '../../elements/MgpFormInput/MgpFormInput';
import MgpMessage from '../../elements/MgpMessage/MgpMessage';
import LoaderModal from '../../modals/common/LoaderModal';
import { signPropositionContract, initSmsSignatureCode } from '../../services/CustomerApiService';
import { handleKeyDown } from '../../utils/utils';
import {IApiErrors} from "../../context/model";


type SignatureFormData = {
    validationCode: string;
 
}

export default function InfoSignatureStep1FormComponent() {

  const navigate = useNavigate();

  const {
    state: { proposition, jwtToken, sessionUid, phoneNumberSMS },
    dispatch,
  } = useAppState();

  const [errorMsg, setErrorMsg] = useState<string | null>();
  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState(false);
  const [attempts, setAttempts ] = useState<number>(3);
  const [isClickable, setIsClickable] = useState<boolean>(true);
  const [timer, setTimer ] = useState<number>(60);

  const onNextAction = async (data: SignatureFormData) => {
    setErrorMsg(null);
    setLoading(true)
    try {
      const token = jwtToken!.accessToken;
      const body = {sessionUid, smsCode: data.validationCode};
 
      const res =  await signPropositionContract(token, proposition!.propositionId, body);

      setSuccess(true);
      setLoading(false);
      dispatch({type: 'NEXT_INFO_STEP', path: APP_URLS.infoSignatureStep2Page});
      dispatch({type: 'LIST_SIGNED_DOCUMENT', signedDocument: res.data});
      navigate({
        pathname: APP_URLS.infoSignatureStep2Page,
        search: `?id=${proposition!.propositionId}`,
      }, {replace: true});
    } catch (error) {
      //check error code
      if (attempts > 0) {
        setAttempts(attempts -1 )
      } 
      setLoading(false);
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 401) {
        //const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: Code d'authentification invalide");
      } else if (err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  }

  const validationSchema = Yup.object().shape({
    validationCode: Yup.string()
    .required(ERROR_MESSAGES.requiredMsg)
    .matches(/^\d+$/, ERROR_MESSAGES.invalidMsg )
    .max(6, ERROR_MESSAGES.invalidMsg)
    .min(6, ERROR_MESSAGES.invalidMsg),
    });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SignatureFormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      validationCode: '',
    },
    resolver: yupResolver(validationSchema),
  });

    const handleClick = async () => {
      setIsClickable(false);
      setAttempts(3);
      const token = jwtToken!.accessToken;
      const res = await initSmsSignatureCode(token, proposition!.propositionId, phoneNumberSMS);

      dispatch({type: 'INIT_SMS', sessionUid: res.data.sessionUid});

      let interval = setInterval(() => {
        setTimer((prevTime) => prevTime - 1);
      }, 1000);

      setTimeout(() => {
        setIsClickable(true);
        setTimer(60);
        clearInterval(interval)
      }, 60000);
    }

    const onKeyDown  = (event : any) => {
      if (event.keyCode === 13) {
        event.preventDefault();
      }
    }

    return (          
            <form style={{width: '100%'}}>       
                <div className="form-row">          
                    <div className="form-group mw-33">
                        <MgpFormInput
                            label="Votre code d'authentification"
                            id="validationCode"
                            labelFontWeight='regular'
                            register={register} 
                            errors={errors}
                            required={true}
                            onKeyDown={onKeyDown}
                        />
                    </div>  
                </div>  
                <div className='form-row'>
                  <div className="form-group mw-33">
                    <p className='bg-menthe blanc p-xs grid-flex va-center jc-start'>
                      <i className='icon-info blanc '></i><span>Vous avez <strong>{attempts}</strong> tentatives</span>
                    </p>
                  </div>
                </div>
                 
                
                {isClickable ? <p className='p-y-md'>Vous n'avez pas reçu le code ? <a className="link" onClick={handleClick} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>Cliquez ici pour reçevoir un nouveau code</a></p> : <p className='p-y-md'><span>Vous pouvez demander un nouveau code dans {timer} secondes</span></p>}
                
                {loading && <LoaderModal hasMessage={true}/>}
                <div>
                  {errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={true}/>}
                </div>                
          
                {attempts > 0 ? <StickButtonsBloc nextButtonName='Signer' showNextButton={true} showPreviousButton={false} nextAction={handleSubmit(onNextAction)}/> : <StickButtonsBloc disabledNextButton={true} nextButtonName='Signer' showNextButton={true} showPreviousButton={false} nextAction={handleSubmit(onNextAction)}/>}
            </form>
  )
}
